"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth = void 0;
const axios_1 = require("axios");
const sdk_1 = require("../sdk");
var Auth;
(function (Auth) {
    Auth.verifyCanvasOAuthToken = (data) => {
        const url = '/oauth2/token';
        return sdk_1.SDK.axios.post(url, data);
    };
    Auth.checkPermissionToken = () => {
        const url = '/oauth2/checkPermissionToken';
        return sdk_1.SDK.axios.get(url);
    };
    Auth.refreshCanvasOAuthToken = (data) => {
        const url = '/oauth2/tokenRefresh';
        // Don't use existing axios instance to skip the axios.interceptors.response.use handler
        const instance = axios_1.default.create();
        instance.defaults.baseURL = sdk_1.SDK.axios.defaults.baseURL;
        return instance.post(url, data);
    };
})(Auth = exports.Auth || (exports.Auth = {}));
//# sourceMappingURL=auth.js.map